export const optionActionTypes = {
  CHOOSE_HEADER_OPTION: "CHOOSE_HEADER_OPTION",
  SET_CATEGORY: "SET_CATEGORY",
};
